<template>
  <Modal 
    :id="'cmp-add-genres'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{$t('select_preset')}}</template>

    <template slot="body">
      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column"></th>
            <th class="dt-table2--column"></th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
        <tr
            class="dt-table2--row"
            v-for="item in presetList"
            :key="item.statement_preset_id"
            @click="e => onRowClicked(item)"
          >
            <td class="dt-table2--column">{{item['preset_name']}}</td>
            <td class="dt-table2--column">{{item['notes']}}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">

       
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
    
 
      
    </template>

  </Modal>
</template>

<script>

import InputField from "@/plugins/text-field/input-field";

import Modal from '../../../../dt-plugins/modal/modal';
import { DistributionStatementService } from '../../services/statement.service';

export default {
  props: {


  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],
  data: function() {
    return {
      presetList: [],
     
      searchSize: "single",
    };
  },
  mounted:async function() {
    const resData = await DistributionStatementService.channelPresets(this.channel);

    this.presetList = resData.data.presets;

    console.log("::::::::",resData,":::::::::::")
  },
  computed: {

    
    hRowMarginRight: function() {
      if (this.presetList.length > 380 / 28) {
        return "28px";
      }
    },
  
    channel: function() {
      return this.$route.query.channel;
    },
    statement_id: function() {
      return this.$route.query.statement_id;
    },

  },
  methods: {
    onRowClicked: async function(item) {
      console.log(item,"::::::::::");
      //await DistributionStatementService.setPreset(this.statement_id,item.statement_preset_id);
      this.$emit('load_preset',{statement_id:this.statement_id,statement_preset_id:item.statement_preset_id})
      this.onCancel();
    },
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>